// Variation to use for Split Testing Flags when the flag is disabled
export const DEFAULT_SPLIT_VARIATION = 'control';

export const VariationTypes = {
  ROLLOUT: ['on', 'off'],
} as const;
